import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

export const PublicNav = () => {
  const { t } = useT();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const links = [
    { href: "#how", label: t("nav.howItWorks") },
    { href: "#features", label: t("nav.features") },
    { href: "/pricing", label: t("nav.pricing"), route: true },
    { href: "#faq", label: t("nav.faq") },
  ];

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/"><Logo /></Link>
        <nav className="hidden items-center gap-7 md:flex">
          {links.map((l) => l.route ? (
            <Link key={l.href} to={l.href} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{l.label}</Link>
          ) : (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{l.label}</a>
          ))}
        </nav>
        <div className="hidden items-center gap-2 md:flex">
          <ThemeToggle />
          {user ? (
            <Button onClick={() => navigate("/dashboard")} className="bg-brand-500 hover:bg-brand-600 text-black rounded-xl" data-testid="nav-dashboard-btn">{t("nav.dashboard")}</Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn">{t("auth.login")}</Button>
              <Button onClick={() => navigate("/register")} className="bg-brand-500 hover:bg-brand-600 text-black rounded-xl" data-testid="nav-register-btn">{t("auth.register")}</Button>
            </>
          )}
        </div>
        <div className="flex items-center gap-1 md:hidden">
          <ThemeToggle />
          <Button variant="ghost" size="icon" onClick={() => setOpen(!open)} data-testid="mobile-nav-toggle">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</Button>
        </div>
      </div>
      {open && (
        <div className="border-t border-border bg-background px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-2">
            {links.map((l) => l.route ? (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="py-2 text-sm font-medium">{l.label}</Link>
            ) : (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2 text-sm font-medium">{l.label}</a>
            ))}
            <div className="mt-2 flex flex-col gap-2">
              {user ? (
                <Button onClick={() => navigate("/dashboard")} className="bg-brand-500 hover:bg-brand-600 text-black">{t("nav.dashboard")}</Button>
              ) : (
                <>
                  <Button variant="outline" onClick={() => navigate("/login")}>{t("auth.login")}</Button>
                  <Button onClick={() => navigate("/register")} className="bg-brand-500 hover:bg-brand-600 text-black">{t("auth.register")}</Button>
                </>
              )}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
